exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiFieldSelector__checkboxWrapper___zEPIG {\n  width: 100%;\n  margin-top: -10px; }\n\n.multiFieldSelector__checkboxItemWrapper___1iKYf {\n  margin-top: 10px;\n  height: auto; }\n  .multiFieldSelector__checkboxItemWrapper___1iKYf > label > span:last-child {\n    font-size: 12px;\n    color: #000000;\n    opacity: 65%;\n    font-weight: 500;\n    line-height: 18px;\n    letter-spacing: -0.015em; }\n\n.multiFieldSelector__fullWidth___3JLgD {\n  width: 100%; }\n\n.multiFieldSelector__mobileContent___3mm_n div[class*=\"ant-select-selection-selected-value\"] {\n  color: black; }\n\n.multiFieldSelector__desktopSelect___23G5A {\n  margin-bottom: 12px; }\n  .multiFieldSelector__desktopSelect___23G5A div[class*=\"ant-select-selection--multiple\"] {\n    overflow: auto; }\n", ""]);

// exports
exports.locals = {
	"checkboxWrapper": "multiFieldSelector__checkboxWrapper___zEPIG",
	"checkboxItemWrapper": "multiFieldSelector__checkboxItemWrapper___1iKYf",
	"fullWidth": "multiFieldSelector__fullWidth___3JLgD",
	"mobileContent": "multiFieldSelector__mobileContent___3mm_n",
	"desktopSelect": "multiFieldSelector__desktopSelect___23G5A"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/MultiFieldSelector/multiFieldSelector.scss
// module id = 2120
// module chunks = 6